<div
    #listVehicleBottom
    class="list-vehicle-bottom"
>
    <div #resize class="list-vehicle-bottom__resize">

    </div>
    <div class="list-vehicle-bottom__header">
        <div class="column-left">
            <div class="filters-wrapper">
                <div class="search-input">
                    <tk-search 
                        [control]="form.controls['Phrase']"
                        [loading]="false"
                    ></tk-search>
                </div>
                <app-filter-control
                    *ngIf="filtersStatusConfig"
                    [selectedControlValue]="filtersStatusCurrentFilters"
                    (onSubmitFilters$)="onSubmitFilters($event, filtersStatusConfig)"
                    [data]="filtersStatusConfig"
                    [optionsSelectedCount]="(form.controls['Status'].value !== null) ? 1 : 0"
                ></app-filter-control>
                <app-filter-control
                    *ngIf="filtersGroupConfig"
                    [selectedControlValue]="filtersGroupCurrentFilters"
                    (onSubmitFilters$)="onSubmitFilters($event, filtersGroupConfig)"
                    [data]="filtersGroupConfig"
                    [optionsSelectedCount]="form.controls['Tags'].value?.length"
                    [isVisibleSearchInput]="true"
                ></app-filter-control>
                <app-filter-control
                    *ngIf="filtersLockConfig && hasBlockerReadPermissionUser"
                    [selectedControlValue]="filtersLockCurrentFilters"
                    (onSubmitFilters$)="onSubmitFilters($event, filtersLockConfig)"
                    [data]="filtersLockConfig"
                    [optionsSelectedCount]="(form.controls['IgnitionBlockerState'].value) ? 1 : 0"
                ></app-filter-control>
            </div>
        </div>
        <div class="colmn-right">
            <!-- <span>Widok:</span> -->
            <!-- <i class="pi pi-list"></i> -->
            <!-- <button>
                <i class="pi pi-list"></i>
            </button>
            <button>
                <i class="pi pi-cog"></i>
            </button> -->
            <button (click)="isVisibleConfigColumnPanel = true">
                <i class="pi pi-cog"></i>
            </button>
            <button (click)="newNavigationService.toMainPanel()">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div #listWrapper class="list-vehicle-bottom__list-wrapper">
        <div *ngIf="isVisibleLoader" class="loader-wrapper">
            <p-skeleton *ngFor="let item of [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]" height="4rem"></p-skeleton>
        </div>

        <div *ngIf="!isVisibleLoader && cols?.length" class="list-vehicle-bottom__list-wrapper__list">
            <p-table
                *ngIf="isVisibleList"
                [columns]="configListSortColumns | sortVehicleFullListColumns : cols"
                [value]="vehicles"
                [scrollable]="true"
                [scrollHeight]="scrollHeight"
                [virtualScroll]="true"
                [virtualScrollItemSize]="70"
                [rows]="vehicles.length"
                [frozenWidth]="'200px'"
                [sortField]="sortField"
                [sortOrder]="sortOrder"
                [customSort]="true"
                (sortFunction)="setColumnSorted($event)"
            >
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th
                            *ngFor="let col of columns" [style]="columnsWidth[col.field] || ''"
                            [pSortableColumn]="sortableColumns[col.field] || null"
                            [ngClass]="{ 
                                'p-frozen-column': col.field === 'vehicleName'
                            }"
                            class="header-column"
                        >
                            {{ col.header }}
                            <p-sortIcon *ngIf="sortableColumns[col.field]" [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>

                <ng-template
                    pTemplate="body"
                    let-rowData
                    let-rowIndex="rowIndex"
                    let-columns="columns"
                >
                    <tr
                        (click)="onClickVehicle(rowData)"
                        class="list-vehicle-bottom__list-wrapper__list__item"
                        style="height:46px;"
                    >
                        <td
                            *ngFor="let col of columns" [style]="columnsWidth[col.field] || 'min-width: 80px; max-width: 80px;'"
                            [ngClass]="{ 'p-frozen-column': col.field === 'vehicleName' }"
                        >
                            <ng-container *ngIf="col.field === 'St'">
                                <div class="custom-column">
                                    <div
                                        [ngClass]="{
                                            'tk-i-driving': (rowData[col.field] === 1),
                                            'tk-i-parked': (rowData[col.field] === 2),
                                            'vehicle-status-no-gps': (rowData[col.field] === 3),
                                            'vehicle-status-no-gsm': (rowData[col.field] === 4),
                                            'tk-i-disconnected': (rowData[col.field] === 5),
                                            'vehicle-status-towed': (rowData[col.field] === 6)
                                        }"
                                        class="w-5 h-5"
                                    ></div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'time'">
                                <app-calculate-time [data]="rowData"></app-calculate-time>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'vehicleName'">
                                <span [title]="rowData.Nm" class="vehicle-name">
                                    {{ rowData.Nm }}
                                </span>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'speed'">
                                <app-calculate-speed [data]="rowData"></app-calculate-speed>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'address'">
                                <tk-vehicle-location class="address" [location]="rowData.LL"></tk-vehicle-location>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'driver'">
                                <span class="driver-name">
                                    {{ rowData.LastDriver ? (rowData.LastDriver | fullName) : '-' }}
                                </span>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'etoll'">
                                <app-e-toll-status [data]="rowData"></app-e-toll-status>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'sent'">
                                <app-e-toll-status [data]="rowData" [isSentGeo]="true"></app-e-toll-status>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'gps'">
                                <app-singal-status 
                                    [data]="rowData"
                                    [scaleMax]="12"
                                    [parameterType]="PARAMETER_TYPE.VisibleSatellites"
                                ></app-singal-status>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'gsm'">
                                <app-singal-status 
                                    [data]="rowData"
                                    [scaleMax]="32"
                                    [parameterType]="PARAMETER_TYPE.GSMLevel"
                                ></app-singal-status>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'fuel'">
                                <app-fuel-status [data]="rowData"></app-fuel-status>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'rpm'">
                                <app-vehicle-text-value-control
                                    [data]="rowData"
                                    [group]="7"
                                    paramPathToDisplay="V"
                                    unit="rpm"
                                ></app-vehicle-text-value-control>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'controls'">
                                <app-controls-status [data]="rowData"></app-controls-status>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'lock'">
                                <app-lock-status [data]="rowData"></app-lock-status>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'networkType'">
                                <span>
                                    {{ rowData.DN }}
                                </span>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'tacho'">
                                <app-tacho-status-full-list [data]="rowData"></app-tacho-status-full-list>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'deviceID'">
                                <app-vehicle-text-value-control
                                    [data]="rowData"
                                    [isCopyActive]="true"
                                    [isParamValue]="true"
                                    paramPathToDisplay="SN"
                                    unit=""
                                ></app-vehicle-text-value-control>
                            </ng-container>

                            <ng-container *ngIf="col.field === 'sentGeoID'">
                                <app-vehicle-text-value-control
                                    [data]="rowData"
                                    [isCopyActive]="true"
                                    [isParamValue]="true"
                                    paramPathToDisplay="SentGeoId"
                                    unit=""
                                ></app-vehicle-text-value-control>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
            </p-table>

        </div>
    </div>

    <app-list-full-vehicle-column-config 
        *ngIf="isVisibleConfigColumnPanel"
        (onSave$)="prepareListToDisplayWithConfigSort($event)"
        (onHide$)="isVisibleConfigColumnPanel = false"
    ></app-list-full-vehicle-column-config>
</div>
